__turbopack_context__.v({
  "letters-list-button": "AlphaButtons-module-scss-module__Dl4VWa__letters-list-button",
  "letters-list-button-active": "AlphaButtons-module-scss-module__Dl4VWa__letters-list-button-active",
  "letters-list-button-disabled": "AlphaButtons-module-scss-module__Dl4VWa__letters-list-button-disabled",
  "letters-list-item": "AlphaButtons-module-scss-module__Dl4VWa__letters-list-item",
  "main": "AlphaButtons-module-scss-module__Dl4VWa__main",
});
